
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34802',
  depVersions: {
  "documents-public-ui": "static-1.34802",
  "atom": "static-1.5194",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2616",
  "client-types": "static-1.481",
  "cssUtils": "static-1.826",
  "customer-data-filters-ui": "static-1.40215",
  "customer-data-objects": "static-1.7797",
  "customer-data-property-utils": "static-1.8214",
  "documents-lib": "static-1.34807",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.346",
  "FormsCommonComponents": "static-1.86138",
  "FormUrlGenerator": "static-2.4840",
  "foundations-theming-specialty": "static-1.2267",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5711",
  "hs-test-utils": "static-1.8139",
  "hub-http": "static-1.6341",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11897",
  "HubStyleTokens": "static-2.11590",
  "I18n": "static-7.1639",
  "icons": "static-2.654",
  "jasmine-immutable": "static-1.3139",
  "jasmine-runner": "static-1.6576",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7271",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5516",
  "quartz": "static-1.7183",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16802",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5429",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8293",
  "reference-resolvers-lite": "static-1.8215",
  "reporting-data": "static-1.68055",
  "reporting-reports": "static-1.67733",
  "reporting-snowflake": "static-1.56673",
  "reporting-testing-lib": "static-1.9988",
  "reporting-visualizations": "static-1.60131",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9065",
  "sanitize": "static-1.4594",
  "sanitize-text": "static-1.8263",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1862",
  "signup-constants": "static-1.19140",
  "signup-ui-url-generator": "static-2.8176",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4877",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4878",
  "ui-addon-form-validation": "static-1.11109",
  "ui-asset-management-lib": "static-1.11186",
  "ui-images": "static-2.1184",
  "UIComponents": "static-3.8536",
  "usage-tracker": "static-1.7467",
  "usage-tracker-container": "static-1.7457",
  "usage-tracker-core": "static-1.7317",
  "viral-links-lib": "static-1.7187",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9780",
  "foundations-components": "static-1.8175",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.961",
  "quartz-core": "static-1.6402",
  "quick-fetch": "static-1.4005",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4775",
  "ui-addon-i18n": "static-1.11267",
  "ui-addon-upgrades": "static-9.18157",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3485",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3460",
  "quartz-webpack": "static-1.3407",
  "foundations-assets": "static-1.4991",
  "foundations-theming": "static-1.4551",
  "hub-http-shared-msw-handlers": "static-1.10261",
  "hubspotter-http": "static-1.4738",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7365",
  "crm-message-bus": "static-1.43297",
  "customer-data-filters-ui-msw-helpers": "static-1.22650",
  "customer-data-objects-ui-components": "static-1.13148",
  "customer-data-reference-ui-components": "static-1.13292",
  "customer-data-ui-utilities": "static-1.9943",
  "events-data-lib": "static-1.352",
  "framework-builder-read-service-client": "static-1.4091",
  "framework-data-schema-quick-fetch": "static-1.6917",
  "framework-data-schema-resolvers": "static-1.7012",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3674",
  "inbound-db-properties-service-client": "static-1.3934",
  "multi-account-reference-resolvers": "static-1.1100",
  "onboarding-tours": "static-1.16831",
  "reporting-datasets-permissions-lib": "static-1.14023",
  "ui-addon-teams": "static-1.21706",
  "quartz-auth": "static-1.858",
  "ui-business-units-lib": "static-1.9185",
  "usage-tracker-session-replay": "static-1.5153",
  "ai-components-ui-library": "static-1.9258",
  "ContentUtils": "static-1.68715",
  "customer-data-properties": "static-1.51977",
  "forms-ai-lib": "static-1.4509",
  "forms-utils-lib": "static-1.12810",
  "foundations-components-test-utils": "static-1.5658",
  "react-dnd-compat": "static-1.4733",
  "react-tinymce": "static-1.55561",
  "tinymce-config": "static-2.54687",
  "ui-gdpr-components": "static-1.10468",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3536",
  "HeadJS": "static-2.771",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3250",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.169",
  "ui-fonts": "static-1.852",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4445",
  "csstype": "static-1.50",
  "quartz-head": "static-1.848",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1662",
  "external-options-client-types": "static-1.4214",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.858",
  "frontend-preferences-client": "static-1.8045",
  "graphql": "static-1.83",
  "persist-promise": "static-1.3819",
  "reporting-client-types": "static-1.2570",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25729",
  "hubspot-apollo-client": "static-1.4996",
  "foundations-components-legacy": "static-1.1200",
  "quartz-routing": "static-1.613",
  "hs-story-utils": "static-1.9542",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.349",
  "timezone-utils": "static-2.5361",
  "seat-types-lib": "static-1.280",
  "react-create-root-preference": "static-1.37",
  "bend-plugin-foundations-components": "static-1.4444",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2198",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.846",
  "mobile-manifest-mixins": "static-1.545",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.858",
  "quartz-tracking": "static-1.562",
  "trellis-components": "static-1.2217",
  "bend-plugin-chirp-manifest": "static-1.185",
  "chirp-fetch": "static-1.2006",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6098",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4169",
  "bender-build-tools": "static-1.3297",
  "bend-plugin-foundations-theming": "static-1.3034",
  "stylex": "static-1.35",
  "restore-request-side-panel-lib": "static-1.1175",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.294",
  "pulse": "static-1.723",
  "conditional-properties-service-client": "static-1.3885",
  "crm-pipelines-api-client-types": "static-1.4224",
  "fdsr-migration-layer": "static-1.131",
  "multi-currency-client-types": "static-1.3778",
  "getting-started-shared-tasks": "static-1.18744",
  "growth-data-modal": "static-1.5626",
  "growth-onboarding-confetti": "static-1.3184",
  "growth-onboarding-next-action-utils": "static-1.2261",
  "navigation-components": "static-1.18306",
  "onboarding-tours-client": "static-1.5045",
  "onboarding-tours-utils": "static-1.897",
  "ui-shepherd-react": "static-3.10370",
  "ui-shepherd-tracker": "static-1.7751",
  "ui-universal-auth": "static-1.9121",
  "user-context": "static-1.5227",
  "hubspotter-http-shared-msw-handlers": "static-1.10259",
  "magpie-lib": "static-1.5629",
  "navigation-messaging": "static-1.7633",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21866",
  "copilot-toolkit": "static-1.11440",
  "cms-field-types": "static-1.4933",
  "content-icons-ui": "static-1.2260",
  "integrations-lib": "static-1.16535",
  "calling-global-api": "static-1.64921",
  "calling-internal-common": "static-1.31428",
  "calling-lifecycle-internal": "static-1.66303",
  "calling-lifecycle-messages": "static-1.58597",
  "commerce-products-lib": "static-1.10007",
  "crm-links": "static-1.6426",
  "customer-data-properties-shared-msw-handlers": "static-1.9588",
  "file-manager-components": "static-1.23961",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4305",
  "meetings-icalendar-utils-lib": "static-1.752",
  "object-builder-ui-client": "static-1.49157",
  "pipeline-validation-client-types": "static-1.4053",
  "property-value-citations": "static-1.2591",
  "smart-property-lib": "static-1.7850",
  "tiered-pricing": "static-1.1533",
  "ui-addon-iframeable": "static-1.9185",
  "zustand": "static-1.74",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20043",
  "tinymce-themes": "static-1.56657",
  "data-token-picker": "static-1.16625",
  "hub-http-contrib": "static-1.3161",
  "interframe": "static-3.4878",
  "tinymce-data": "static-1.40772",
  "tinymce-plugins": "static-1.57801",
  "ui-addon-sales-email": "static-1.5329",
  "onboarding-scopes": "static-1.6579",
  "ui-addon-opt": "static-4.8479",
  "apollo-link-hub-http": "static-2.4770",
  "hubspot-apollo-cache": "static-1.455",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.292",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1059",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6101",
  "event-emitter": "static-1.1067",
  "bend-plugin-pulse": "static-1.226",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2173",
  "growth-onboarding-next-action-components": "static-1.2289",
  "user-context-client": "static-1.4698",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5089",
  "nest": "static-1.351",
  "reactive-lib": "static-1.845",
  "simple-logging-lib": "static-1.3167",
  "unified-auth-core-lib": "static-1.917",
  "getting-started-shared-tasks-store": "static-1.17862",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1134",
  "integrations-error-boundary-lib": "static-1.13950",
  "integrations-tracking-lib": "static-1.5724",
  "native-integrations-shared-strings": "static-1.7900",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10481",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.635",
  "calling-error-reporting": "static-1.31435",
  "shared-worker-versioning": "static-1.11153",
  "calling-usage-tracker": "static-1.6662",
  "voice-sms-access-library": "static-1.1450",
  "customer-data-tracking": "static-1.7006",
  "commerce-permissions": "static-1.894",
  "products-iframe-lib": "static-1.8262",
  "products-ui-components-shared-msw-handlers": "static-1.10643",
  "location-customization-utils-lib": "static-1.9604",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4268",
  "video-components-external": "static-1.11665",
  "video-data-lib": "static-1.35323",
  "data-agent-kit": "static-1.399",
  "feedback-loader": "static-1.29526",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10344",
  "fsm": "static-1.3847",
  "policy-lib": "static-1.6903",
  "react-colorpicker": "static-2.10326",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10407",
  "FileManagerLib": "static-1.39601",
  "NamespacedHubStyle": "static-2.9141",
  "FileManagerCore": "static-1.39460",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7948",
  "layout-dnd-components": "static-1.12682",
  "layout-dnd-utils": "static-1.11657",
  "react-codemirror": "static-1.10745",
  "ui-addon-emoji-picker": "static-1.10005",
  "ui-brand-identity-lib": "static-1.15714",
  "InboxConnectUtils": "static-4.15126",
  "meetings-connect-utils-lib": "static-1.7724",
  "breeze-engine-core": "static-1.412",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3133",
  "adobe-sign-auth-lib": "static-1.26",
  "ads-unified-auth-lib": "static-1.396",
  "google-sheets-integration-lib": "static-1.590",
  "microsoft-drive-integration-lib": "static-1.728",
  "surveymonkey-integration-lib": "static-1.45",
  "slack-ui-library": "static-1.10515",
  "calling-orchestration-schema": "static-1.36227",
  "sales-views-client-types": "static-1.4375",
  "crm-record-cards-service-types": "static-1.3673",
  "content-media-composition-data-lib": "static-1.12681",
  "content-media-compositions": "static-2.16688",
  "media-bridge-lib": "static-1.19138",
  "trellis-story-utils": "static-1.4629",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6104",
  "FileManagerImages": "static-1.37112",
  "video-components": "static-1.13667",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4655",
  "video-embed": "static-1.36157",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8822",
  "ui-coaching-tips": "static-1.28891",
  "ContentData": "static-1.68790",
  "layout-data-lib": "static-1.9982",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22353",
  "outpost": "static-1.4287",
  "growth-onboarding-feedback-components": "static-1.6696",
  "advanced-menus-core": "static-1.15332",
  "advanced-menus-lib": "static-1.12243",
  "ExportDialog": "static-6.10498",
  "ui-memberships-settings-lib": "static-1.34363",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15331",
  "simple-menus-lib": "static-1.16848"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34802",
  "atom": "/atom/static-1.5194",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2616",
  "client-types": "/client-types/static-1.481",
  "cssUtils": "/cssUtils/static-1.826",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40215",
  "customer-data-objects": "/customer-data-objects/static-1.7797",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8214",
  "documents-lib": "/documents-lib/static-1.34807",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.346",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86138",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4840",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2267",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5711",
  "hs-test-utils": "/hs-test-utils/static-1.8139",
  "hub-http": "/hub-http/static-1.6341",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11897",
  "HubStyleTokens": "/HubStyleTokens/static-2.11590",
  "I18n": "/I18n/static-7.1639",
  "icons": "/icons/static-2.654",
  "jasmine-immutable": "/jasmine-immutable/static-1.3139",
  "jasmine-runner": "/jasmine-runner/static-1.6576",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7271",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5516",
  "quartz": "/quartz/static-1.7183",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16802",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5429",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8293",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8215",
  "reporting-data": "/reporting-data/static-1.68055",
  "reporting-reports": "/reporting-reports/static-1.67733",
  "reporting-snowflake": "/reporting-snowflake/static-1.56673",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9988",
  "reporting-visualizations": "/reporting-visualizations/static-1.60131",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9065",
  "sanitize": "/sanitize/static-1.4594",
  "sanitize-text": "/sanitize-text/static-1.8263",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1862",
  "signup-constants": "/signup-constants/static-1.19140",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8176",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4877",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4878",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11109",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11186",
  "ui-images": "/ui-images/static-2.1184",
  "UIComponents": "/UIComponents/static-3.8536",
  "usage-tracker": "/usage-tracker/static-1.7467",
  "usage-tracker-container": "/usage-tracker-container/static-1.7457",
  "usage-tracker-core": "/usage-tracker-core/static-1.7317",
  "viral-links-lib": "/viral-links-lib/static-1.7187",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9780",
  "foundations-components": "/foundations-components/static-1.8175",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.961",
  "quartz-core": "/quartz-core/static-1.6402",
  "quick-fetch": "/quick-fetch/static-1.4005",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4775",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11267",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18157",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3485",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3460",
  "quartz-webpack": "/quartz-webpack/static-1.3407",
  "foundations-assets": "/foundations-assets/static-1.4991",
  "foundations-theming": "/foundations-theming/static-1.4551",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10261",
  "hubspotter-http": "/hubspotter-http/static-1.4738",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7365",
  "crm-message-bus": "/crm-message-bus/static-1.43297",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22650",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13148",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13292",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9943",
  "events-data-lib": "/events-data-lib/static-1.352",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4091",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6917",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7012",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3674",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3934",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1100",
  "onboarding-tours": "/onboarding-tours/static-1.16831",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14023",
  "ui-addon-teams": "/ui-addon-teams/static-1.21706",
  "quartz-auth": "/quartz-auth/static-1.858",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9185",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5153",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9258",
  "ContentUtils": "/ContentUtils/static-1.68715",
  "customer-data-properties": "/customer-data-properties/static-1.51977",
  "forms-ai-lib": "/forms-ai-lib/static-1.4509",
  "forms-utils-lib": "/forms-utils-lib/static-1.12810",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5658",
  "react-dnd-compat": "/react-dnd-compat/static-1.4733",
  "react-tinymce": "/react-tinymce/static-1.55561",
  "tinymce-config": "/tinymce-config/static-2.54687",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10468",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3536",
  "HeadJS": "/HeadJS/static-2.771",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3250",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.169",
  "ui-fonts": "/ui-fonts/static-1.852",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4445",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.848",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1662",
  "external-options-client-types": "/external-options-client-types/static-1.4214",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.858",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8045",
  "graphql": "/graphql/static-1.83",
  "persist-promise": "/persist-promise/static-1.3819",
  "reporting-client-types": "/reporting-client-types/static-1.2570",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25729",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4996",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1200",
  "quartz-routing": "/quartz-routing/static-1.613",
  "hs-story-utils": "/hs-story-utils/static-1.9542",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.349",
  "timezone-utils": "/timezone-utils/static-2.5361",
  "seat-types-lib": "/seat-types-lib/static-1.280",
  "react-create-root-preference": "/react-create-root-preference/static-1.37",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4444",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2198",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.846",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.545",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.858",
  "quartz-tracking": "/quartz-tracking/static-1.562",
  "trellis-components": "/trellis-components/static-1.2217",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.185",
  "chirp-fetch": "/chirp-fetch/static-1.2006",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6098",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4169",
  "bender-build-tools": "/bender-build-tools/static-1.3297",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3034",
  "stylex": "/stylex/static-1.35",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1175",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.294",
  "pulse": "/pulse/static-1.723",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3885",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4224",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.131",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3778",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18744",
  "growth-data-modal": "/growth-data-modal/static-1.5626",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3184",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2261",
  "navigation-components": "/navigation-components/static-1.18306",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5045",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.897",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10370",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7751",
  "ui-universal-auth": "/ui-universal-auth/static-1.9121",
  "user-context": "/user-context/static-1.5227",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10259",
  "magpie-lib": "/magpie-lib/static-1.5629",
  "navigation-messaging": "/navigation-messaging/static-1.7633",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21866",
  "copilot-toolkit": "/copilot-toolkit/static-1.11440",
  "cms-field-types": "/cms-field-types/static-1.4933",
  "content-icons-ui": "/content-icons-ui/static-1.2260",
  "integrations-lib": "/integrations-lib/static-1.16535",
  "calling-global-api": "/calling-global-api/static-1.64921",
  "calling-internal-common": "/calling-internal-common/static-1.31428",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66303",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58597",
  "commerce-products-lib": "/commerce-products-lib/static-1.10007",
  "crm-links": "/crm-links/static-1.6426",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9588",
  "file-manager-components": "/file-manager-components/static-1.23961",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4305",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.752",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49157",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4053",
  "property-value-citations": "/property-value-citations/static-1.2591",
  "smart-property-lib": "/smart-property-lib/static-1.7850",
  "tiered-pricing": "/tiered-pricing/static-1.1533",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9185",
  "zustand": "/zustand/static-1.74",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20043",
  "tinymce-themes": "/tinymce-themes/static-1.56657",
  "data-token-picker": "/data-token-picker/static-1.16625",
  "hub-http-contrib": "/hub-http-contrib/static-1.3161",
  "interframe": "/interframe/static-3.4878",
  "tinymce-data": "/tinymce-data/static-1.40772",
  "tinymce-plugins": "/tinymce-plugins/static-1.57801",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5329",
  "onboarding-scopes": "/onboarding-scopes/static-1.6579",
  "ui-addon-opt": "/ui-addon-opt/static-4.8479",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4770",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.455",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.292",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1059",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6101",
  "event-emitter": "/event-emitter/static-1.1067",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.226",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2173",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2289",
  "user-context-client": "/user-context-client/static-1.4698",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5089",
  "nest": "/nest/static-1.351",
  "reactive-lib": "/reactive-lib/static-1.845",
  "simple-logging-lib": "/simple-logging-lib/static-1.3167",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.917",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17862",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1134",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13950",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5724",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7900",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10481",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.635",
  "calling-error-reporting": "/calling-error-reporting/static-1.31435",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11153",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6662",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1450",
  "customer-data-tracking": "/customer-data-tracking/static-1.7006",
  "commerce-permissions": "/commerce-permissions/static-1.894",
  "products-iframe-lib": "/products-iframe-lib/static-1.8262",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10643",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9604",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4268",
  "video-components-external": "/video-components-external/static-1.11665",
  "video-data-lib": "/video-data-lib/static-1.35323",
  "data-agent-kit": "/data-agent-kit/static-1.399",
  "feedback-loader": "/feedback-loader/static-1.29526",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10344",
  "fsm": "/fsm/static-1.3847",
  "policy-lib": "/policy-lib/static-1.6903",
  "react-colorpicker": "/react-colorpicker/static-2.10326",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10407",
  "FileManagerLib": "/FileManagerLib/static-1.39601",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9141",
  "FileManagerCore": "/FileManagerCore/static-1.39460",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7948",
  "layout-dnd-components": "/layout-dnd-components/static-1.12682",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11657",
  "react-codemirror": "/react-codemirror/static-1.10745",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10005",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15714",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15126",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7724",
  "breeze-engine-core": "/breeze-engine-core/static-1.412",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3133",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.26",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.396",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.590",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.728",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.45",
  "slack-ui-library": "/slack-ui-library/static-1.10515",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36227",
  "sales-views-client-types": "/sales-views-client-types/static-1.4375",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3673",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12681",
  "content-media-compositions": "/content-media-compositions/static-2.16688",
  "media-bridge-lib": "/media-bridge-lib/static-1.19138",
  "trellis-story-utils": "/trellis-story-utils/static-1.4629",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6104",
  "FileManagerImages": "/FileManagerImages/static-1.37112",
  "video-components": "/video-components/static-1.13667",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4655",
  "video-embed": "/video-embed/static-1.36157",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8822",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28891",
  "ContentData": "/ContentData/static-1.68790",
  "layout-data-lib": "/layout-data-lib/static-1.9982",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22353",
  "outpost": "/outpost/static-1.4287",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6696",
  "advanced-menus-core": "/advanced-menus-core/static-1.15332",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12243",
  "ExportDialog": "/ExportDialog/static-6.10498",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34363",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15331",
  "simple-menus-lib": "/simple-menus-lib/static-1.16848"
}
};
